/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	SET_USERS(state, users) {
		state.users = users;
	},
	SET_USERS2(state, users) {
		state.users2 = users;
	},
	SET_USERS3(state, users) {
		state.users3 = users;
	},
	REMOVE_USER(state, itemId) {
		const userIndex = state.users.findIndex(u => u._id == itemId);
		state.users.splice(userIndex, 1);
	},
	UPDATE_USER(state, user) {
		const idx = state.users.findIndex(t => t._id === user.id);
		if (idx !== -1) {
			Object.assign(state.users[idx], user);
		}
	},
	SET_TOTAL_USERS(state, total) {
		state.total = total;
	},
	SET_TOTAL_USERS2(state, total) {
		state.total2 = total;
	},
	SET_TOTAL_USERS3(state, total) {
		state.total3 = total;
	},
	ADD_USER(state, user) {
		state.users.unshift(user);
	}
};
